import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string().required("שם המוצר הוא שדה חובה"),
  price: Yup.number()
    .typeError("מחיר חייב להיות מספר")
    .required("מחיר הוא שדה חובה")
    .positive("המחיר חייב להיות מספר חיובי"),
  description: Yup.string().nullable(true).optional(),

  parentCategoryId: Yup.number()
    .typeError("בחרי קטגוריה ראשית")
    .moreThan(0, "בחרי קטגוריה ראשית")
    .required("קטגוריה ראשית היא שדה חובה"),

  categoryId: Yup.number()
    .typeError("בחרי תת-קטגוריה")
    .moreThan(0, "בחרי תת-קטגוריה")
    .required("תת-קטגוריה היא שדה חובה"),

  subCategoryId: Yup.number().typeError("בחרי תת-תת-קטגוריה").min(0),

  image: Yup.mixed().when("id", {
    is: (v) => v === 0,
    then: (schema) => schema.required("יש להעלות תמונה"),
    otherwise: (schema) => schema.nullable().optional(),
  }),
});
